import * as Services from "../models/swagger/generated-data-service";

export const DataService = {
    getStates: Services.StateService.state,
    getCountiesByPortal: Services.CountyService.state, // <-- not sure if this is correct
    getCounty: Services.CountyService.county1,
    getDivisions: Services.DivisionService.county,
    getCourtTypes: Services.CourtTypeService.courtType,
    getCaseTypes: Services.CaseTypeService.division,
    syncCaseTypes: Services.CaseTypeService.sync,
    getPortalCaseTypes: Services.CaseTypeService.portal,
    getCaseSubTypes: Services.CaseSubTypeService.caseType,
    getCaseSubTypesByDivision: Services.CaseSubTypeService.division,
    getPartyTypes: Services.PartyTypeService.partyType,
    getDocumentTypes: Services.DocumentTypeService.county1,
    getDocumentTypesByFilingCode: Services.DocumentTypeService.filingCode,
    getDocumentTypesByCounty: Services.DocumentTypeService.county,
    getFees: Services.FeeService.fee,
    getCoversheetCourtTypes: Services.CoversheetService.courttypes,
    getCoversheetCaseTypes: Services.CoversheetService.caseTypes,
    getCoversheetCaseSubTypes: Services.CoversheetService.caseSubTypes,
    getJudicialOfficers: Services.DivisionService.judicialofficers,
    getFilingCodes: Services.CodesService.filing1,
    getFilingComponents: Services.CodesService.filingCode,
    getComponentsByCounty: Services.CodesService.county1,
    getOptServByFilingCode: Services.CodesService.filingCode1,
    getDamagesCodes: Services.CodesService.damage1,
    getRemedyCodes: Services.CodesService.remedy1,
    getJPCSV: Services.JusticeOfPeaceLocatorService.file,
    getJP: Services.JusticeOfPeaceLocatorService.justiceOfPeaceLocator,
};

export const TagService = {
    getDataTags: Services.DataTagService.dataTag,
    getActiveDataTags: Services.DataTagService.active,
    getDataTag: Services.DataTagService.dataTag1,
    updateOrInsertDataTag: Services.DataTagService.insert,
    deleteDataTag: Services.DataTagService.delete,
    getDocTags: Services.DocumentTagService.documentTag,
    getActiveDocTags: Services.DocumentTagService.active,
    getDocTag: Services.DocumentTagService.documentTag1,
    updateOrInsertDocTag: Services.DocumentTagService.insert,
    deleteDocTag: Services.DocumentTagService.delete,
};

export const TylerDataService = {
    getCountiesByPortal: Services.TylerCountyService.state, // <-- not sure if this is correct
    getCountyByID: Services.TylerCountyService.tylerCounty1,
    getDivisions: Services.TylerDivisionService.county,
    getDivisionByID: Services.TylerDivisionService.tylerDivision,
    getCaseTypes: Services.TylerCaseTypeService.division,
    getCaseTypeByID: Services.TylerCaseTypeService.tylerCaseType,
    getStagingCaseTypes: Services.TylerCaseTypeService.staging,
    syncCaseTypes: Services.TylerCaseTypeService.sync,
    getPortalCaseTypes: Services.TylerCaseTypeService.portal,
    getCaseSubTypes: Services.TylerCaseSubTypeService.caseType,
    getCaseSubTypesByDivision: Services.TylerCaseSubTypeService.division,
    getPartyTypes: Services.TylerPartyTypeService.tylerPartyType,
    getDocumentTypes: Services.TylerDocumentTypeService.county1,
    getDocumentTypesByFilingCode: Services.TylerDocumentTypeService.filingCode,
    getDocumentTypesByCounty: Services.TylerDocumentTypeService.county,
    getFees: Services.TylerFeeService.tylerFee,
    getFilingCodes: Services.TylerCodesService.filing1,
    getFilingComponentsByFilingCode: Services.TylerCodesService.filingCode,
    getFilerTypes: Services.TylerCodesService.filer1,
    getOptServByFilingCode: Services.TylerCodesService.filingCode1,
    getDamagesCodes: Services.TylerCodesService.damage1,
    getRemedyCodes: Services.TylerCodesService.remedy1,
};
